import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Providers } from "./providers.jsx";
import { WalletProvider } from "@coinbase/onchainkit/wallet";
// wagmi setup
import { WagmiConfig, createConfig } from 'wagmi';
import { base } from 'viem/chains';
import { createPublicClient, http } from 'viem';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Provide chains and a client factory to match the installed @wagmi/core expectations.
const chains = [base];

const wagmiConfig = createConfig({
  autoConnect: true,
  chains,
  // createClient will be called with a `{ chain }` and should return a viem public client
  client: ({ chain }) => createPublicClient({ chain, transport: http() }),
});

// React Query client used by wagmi/onchainkit internals (useQuery/useMutation)
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WagmiConfig config={wagmiConfig}>
        <WalletProvider>
          <Providers>
            <App />
          </Providers>
        </WalletProvider>
      </WagmiConfig>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
